import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { isNotNull } from '../../utils/validations';
import { AppColors } from '../../constants';

export const RowStyle = styled(Row)`
  margin: 0 auto !important;
`;
export const ColStyle = styled(Col)`
  padding-right: 1px !important;
  padding-left: 0 !important;
`;

export const SubHeader = styled.h3`
  color: ${(props) => props.color};
  margin: 16px 0 16px 0;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Arial';
`;

export const DateContainer = styled.div`
  background-color: ${AppColors.Gray93};
  padding: 8px;
  display: block;
  clear: both;
  font-family: Arial;
  font-size: 12px;
  color: ${(props) => props.color};
`;

export const DatetimeStyle = styled(Datetime)`
  .form-control {
    color: ${(props) => props.color};
    width: 100%;
    height: 30px;
    font-family: Arial;
    font-size: 12px;
    color: ${AppColors.Gray};
    padding: 8px;
    border-radius: 0 !important;
    border: ${(props) =>
      props.isSubmitted && !isNotNull(props.value)
        ? '1px solid red'
        : props.isSubmitted &&
          (props.errorStoreData['serviceStartDate'] !== '' ||
            props.errorStoreData['serviceStartDate'] === undefined) &&
          isNotNull(props.value)
        ? '1px solid red'
        : '1px solid lightgray'};

    background-color: ${(props) =>
      props.isSubmitted && !isNotNull(props.value)
        ? AppColors.LightPink
        : props.isSubmitted &&
          (props.errorStoreData['serviceStartDate'] !== '' ||
            props.errorStoreData['serviceStartDate'] === undefined) &&
          isNotNull(props.value)
        ? AppColors.LightPink
        : AppColors.White};
  }
`;
export const ErrorContainer = styled.div`
  color: ${AppColors.Red};
`;
